/**
 * Generate page numbers for pagination controls with ellipsis markers.
 *
 * @param currentPage  - The active page (1-indexed).
 * @param totalPages   - Total number of pages.
 * @param maxVisible   - Maximum visible page buttons around the current page (default 5).
 * @returns An array of page numbers and ellipsis markers (`"ellipsis-start"` / `"ellipsis-end"`).
 */
export function getPageNumbers(
  currentPage: number,
  totalPages: number,
  maxVisible = 5,
): (number | string)[] {
  const pages: (number | string)[] = [];

  if (totalPages <= maxVisible + 2) {
    for (let i = 1; i <= totalPages; i++) {
      pages.push(i);
    }
    return pages;
  }

  // Always show first page
  pages.push(1);

  if (currentPage > 3) {
    pages.push("ellipsis-start");
  }

  // Show pages around current page
  const start = Math.max(2, currentPage - 1);
  const end = Math.min(totalPages - 1, currentPage + 1);

  for (let i = start; i <= end; i++) {
    pages.push(i);
  }

  if (currentPage < totalPages - 2) {
    pages.push("ellipsis-end");
  }

  // Always show last page
  pages.push(totalPages);

  return pages;
}
